import Dai from './Dai';

export default Dai;
